/* rein-fbt.js — PDP-V2 R3 (2026-10-07). "Frequently bought together" behaviour for
 * sections/rein-fbt-upsell.liquid. Live total of the checked items; ONE Ajax call adds every
 * checked item (/cart/add.js with an items array, plus the mini-cart sections so the theme's
 * own drawer re-renders), then opens the theme mini cart (window.miniCart, assets/scripts.js).
 * Follows the current product variant (product:variant-change pub/sub + the real form's
 * hidden id). No checkout calls, no third-party code. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rein-fbt]');
  if (!root) return;

  var currency = root.getAttribute('data-currency') || 'USD';
  var fmt = function (cents) {
    try { return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: currency }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  var boxes = function () { return Array.prototype.slice.call(root.querySelectorAll('[data-rein-fbt-cb]')); };
  var thisBox = root.querySelector('[data-rein-fbt-this]');
  var totalEl = root.querySelector('[data-rein-fbt-total]');
  var addBtn = root.querySelector('[data-rein-fbt-add]');
  var msgEl = root.querySelector('[data-rein-fbt-msg]');
  var mainForm = document.querySelector('product-form form[action*="/cart/add"]');

  var setMsg = function (text, cls) {
    if (!msgEl) return;
    msgEl.textContent = text || '';
    msgEl.className = 'rein-fbt__msg' + (cls ? ' ' + cls : '');
  };
  var update = function () {
    var total = 0, n = 0;
    boxes().forEach(function (cb) {
      var item = cb.closest('[data-rein-fbt-item]');
      if (item) item.classList.toggle('is-off', !cb.checked);
      if (cb.checked) { total += parseInt(cb.getAttribute('data-price'), 10) || 0; n += 1; }
    });
    if (totalEl) totalEl.textContent = fmt(total);
    if (addBtn) {
      addBtn.disabled = n === 0;
      addBtn.textContent = n === 0 ? 'Select an item' : (n === 1 ? 'Add selected to cart' : 'Add ' + n + ' selected to cart');
    }
  };
  root.addEventListener('change', function (e) { if (e.target && e.target.hasAttribute('data-rein-fbt-cb')) update(); });

  /* follow the main product's variant (price + id) */
  var syncThis = function (variant) {
    if (!thisBox || !variant) return;
    if (variant.id) thisBox.setAttribute('data-variant-id', variant.id);
    if (typeof variant.price === 'number') {
      thisBox.setAttribute('data-price', variant.price);
      var p = root.querySelector('[data-rein-fbt-this-price]');
      if (p) p.textContent = fmt(variant.price);
    }
    update();
  };
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.productVariantChange) {
    subscribe(PUB_SUB_EVENTS.productVariantChange, function (ev) {
      var v = ev && ev.data && (ev.data.variant || ev.data.selectedVariant);
      if (v) syncThis(v);
    });
  }

  var sectionsToRender = function () {
    var mc = document.querySelector('mini-cart');
    try { return mc && mc.getSectionsToRender ? mc.getSectionsToRender().map(function (s) { return s.section; }) : []; }
    catch (e) { return []; }
  };

  if (addBtn) addBtn.addEventListener('click', function () {
    var items = [];
    boxes().forEach(function (cb) {
      if (!cb.checked) return;
      var id = cb.getAttribute('data-variant-id');
      if (cb.hasAttribute('data-rein-fbt-this') && mainForm) {
        var live = mainForm.querySelector('input[name="id"]');
        if (live && live.value) id = live.value;
      }
      if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
    });
    if (!items.length) return;
    addBtn.classList.add('is-busy'); addBtn.disabled = true; setMsg('Adding…');
    var body = { items: items, sections: sectionsToRender(), sections_url: window.location.pathname };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        addBtn.classList.remove('is-busy'); addBtn.disabled = false;
        if (!res.ok || res.json.status) {
          setMsg(res.json.description || res.json.message || 'Could not add these items. Please try again.', 'is-error');
          return;
        }
        setMsg('Added to your cart.', 'is-ok');
        var mc = window.miniCart || document.querySelector('mini-cart');
        try {
          if (mc && res.json.sections && mc.renderContents) mc.renderContents(res.json);
          if (mc && mc.open) mc.open(addBtn); else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        } catch (e) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
        document.dispatchEvent(new CustomEvent('cart:item-add', { detail: { items: res.json.items || [], context: 'PDP-V2 Frequently bought together' } }));
      })
      .catch(function () {
        addBtn.classList.remove('is-busy'); addBtn.disabled = false;
        setMsg('Could not add these items. Please try again.', 'is-error');
      });
  });

  update();
})();
